import React from 'react'
import moment from 'moment'
import { ICellRendererParams } from 'ag-grid-community'
import styled from '@emotion/styled'
import { DealDetail, DealStatus } from 'api'
import { CountdownTimer, timeConstants } from 'view/components/timers'
import { DateLike } from 'utils'
import * as mixins from 'view/styles/mixins'

const Container = styled.div`
  ${mixins.flexCenterContentCrossAxis};
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  padding: 0 10px;
`

export class AllocationTimeRenderer extends React.Component<ICellRendererParams> {
  render() {
    const { node } = this.props
    const allLeafChildren = node.allLeafChildren ?? []

    if (node.group && node.expanded) {
      return null
    }

    const dealDetails: DealDetail[] = node.group ? allLeafChildren?.map(leaf => leaf.data) : [node.data]
    const endTime = this.getAllocationEndTime(dealDetails)

    return endTime ? (
      <CountdownTimer
        expiryTime={moment(endTime)}
        urgentTime={timeConstants.basketAllocationUrgent}
        expiringTime={timeConstants.basketAllocationExpiring}
      />
    ) : (
      <Container className="validation-cell">-</Container>
    )
  }

  getAllocationEndTime = (dealDetails: DealDetail[]): DateLike | null => {
    const basketAllocation = dealDetails[0].deal.basketAllocation

    if (!basketAllocation || dealDetails[0].deal.status === DealStatus.ALLOCATED) {
      return null
    }

    return basketAllocation.endTime
  }

  refresh = () => {
    this.forceUpdate()
    return true
  }
}
